<template>
  <div class="">
    <div class="m-b-md">
      <form
        action=""
        @submit="doPropertySearch"
      >
        <label
          for="property-search"
          class="label"
        >
          Search properties:
        </label>
        <search
          v-model="searchString"
          :attrs="{ input: { placeholder: 'Property address or OPA account number', id: 'property-search' }}"
          :doing-search="doingSearch"
          @clear="clear"
          @search="doPropertySearch"
        />
      </form>
    </div>

    <!-- Found Section -->
    <div
      v-if="foundSomething!==null"
      class="content"
    >
      <h3
        v-text="$wording.home.title_2"
      />
      <div
        v-if="!foundSomething && !doingSearch"
      >
        <p v-if="!foundSomething">
          {{ $wording.home.text_4 }}
          <help-icon modal="property-not-found" />
        </p>
      </div>
      <p
        v-if="foundProperties && foundProperties.length > 15"
        class="notification m-t-md"
        v-html="$wording.home.text_5"
      />
      <div
        v-if="foundSomething===true"
        class="table-container"
      >
        <table class="table found-properties">
          <thead>
            <tr>
              <th>OPA Number</th>
              <th>OPA Address</th>
              <th class="has-text-centered">
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(property, index) in foundProperties.slice(0, 15)"
              :key="index"
            >
              <td class="has-text-centered">
                {{ property.opa_account_num }}
              </td>
              <td class="has-text-centered">
                {{ property.opa_address }}, {{ property.zip_code }}
              </td>
              <td class="has-text-centered">
                <button
                  class="button go-to-property is-secondary is-small start-plus"
                  @click="$emit('selected-property', property)"
                >
                  <span>Start</span>
                  <span
                    class="icon is-small"
                  >
                    <i
                      class="fas fa-plus"
                      aria-hidden="true"
                    />
                  </span>
                </button>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td colspan="3">
                <p>
                  <strong>Please note:</strong> this database pulls information directly from the Philadelphia Office of Property Assessment (OPA).  In the event that property information is incorrect or needs to be updated, please reach out to the <a
                    href="https://www.phila.gov/departments/office-of-property-assessment/"
                    target="_blank"
                  >Office of Property Assessment <i class="fas fa-external-link" /></a> directly.
                </p>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
    <more-info
      id="property-not-found"
      title="Property not found"
      :text="$wording.home.property_not_found"
    />
  </div>
</template>

<script>
import Search from "@/components/common/Search";
import MoreInfo from '@/components/modals/MoreInfo';
import HelpIcon from '@/components/common/HelpIcon';
export default {
  components: {
    HelpIcon,
    MoreInfo,
    Search,
  },
  data() {
    return {
      doingSearch: null,
      foundSomething: null,
      searchString: '',
    };
  },
  computed: {
    foundProperties() {
      return this.$store.state.properties.foundProperties;
    },
  },
  methods: {
    async doPropertySearch() {
      this.foundSomething = null;
      this.doingSearch = true;

      if (this.searchString === '') {
        this.doingSearch = false;
        return;
      }
      this.foundSomething = await this.$store.dispatch('properties/searchProperty', this.searchString);
      this.doingSearch = false;
    },

    clear() {
      let tempLoadingSubmissions = this.loadingSubmissions;
      Object.assign(this.$data, this.$options.data.apply(this));
      this.loadingSubmissions = tempLoadingSubmissions;
      tempLoadingSubmissions = null;
      this.$store.commit('properties/setFoundProperties', []);
    }, 
  },
};
</script>

<style>

</style>